<template>
  <b-row :class="['mx-0 bg-white base-pagination border border-top-0 pt-1 pb-2', cssClass]">
    <b-col v-if="hasPerPage" class="d-inline-flex align-items-center">
      Rows per page
      <b-dropdown id="dropdown-data-rows-per-page" :text="activeDataPerPage" class="ml-3"
        toggle-class="bg-transparent text-dark shadow-none py-1 px-2">
        <b-dropdown-item v-for="(value, key) in dataPerPageDropdown" :key="`option-data-per-page-${key}`"
          :id="`option-data-per-page-${key}`" @click="setDataPerPage(value)">{{ value }}</b-dropdown-item>
      </b-dropdown>
    </b-col>
    <b-col
      :class="['d-inline-flex justify-content-start align-items-center', { 'justify-content-end': hasPerPage || alignment === 'right' }]">
      <span class="offset-top position-relative">
        <span class="current-page">Page {{ currentPage }}&nbsp;</span> of
        {{ maxPage }}
      </span>
      <b-pagination v-model="paginationVModel" @change="goToPage" align="right"
        class="custom-pagination mb-0 ml-2" hide-goto-end-buttons :per-page="dataPerPage" :total-rows="totalRows">
        <template slot="prev-text">
          <PaginationChevronLeft class="mx-2" :fillColor="currentPage === 1 ? '#c1c4c6' : '#222D37'" />
        </template>
        <template slot="next-text">
          <PaginationChevronRight class="mx-2" :fillColor="currentPage === maxPage ? '#c1c4c6' : '#222D37'" />
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import PaginationChevronLeft from "./PaginationChevronLeft.vue";
import PaginationChevronRight from "./PaginationChevronRight.vue";

export default {
  props: ["currentPage", "totalRows", "dataPerPage", "maxPage", "cssClass", "colClass", "hasPerPage", "alignment", "hasNoVModel"],
  components: { PaginationChevronLeft, PaginationChevronRight },
  computed: {
    activeDataPerPage: {
      get() {
        return this.dataPerPage.toString();
      },
      set(value) {
        return value;
      }
    },
    paginationVModel: {
      get() {
        if (!this.hasNoVModel) return this.currentPage;

        return null;
      },
      set(value) {
        return value;
      }
    }
  },
  data() {
    return {
      dataPerPageDropdown: [10, 50, 100]
    }
  },
  methods: {
    goToPage(page) {
      this.$emit("goToPage", page);
    },
    setDataPerPage(value) {
      this.$emit("setDataPerPage", value);
    }
  },
};
</script>

<style lang="scss">
.base-pagination {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  color: #87929d;
  font-size: 12px;
  border-color: #f0f0f0 !important;
  box-shadow: 0px 2px 5px -3px rgba(67, 67, 67, 0.25);

  .current-page {
    color: #2f3941;
  }

  .offset-top {
    top: 1px;
  }
}

.custom-pagination {
  li {
    display: none !important;

    &:first-child,
    &:last-child {
      display: inline-block !important;
    }

    .page-link {
      font-size: 16px !important;
      height: initial !important;
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}

#dropdown-data-rows-per-page {
  .dropdown-toggle {
    border-color: #E9EBED;
    border-radius: 10px;
  }

  .dropdown-item:active {
    background-color: transparent;
  }
}
</style>
